const { apiPost } = require('./api.js')

// 极验
export function geeInit (params) {
  return apiPost('/usercenter/v3/captcha/geeInit', params)
}
// 极验id
export function getCaptchaIdV4 (params) {
  return apiPost('/usercenter/v3/captcha/getCaptchaIdV4', params)
}

// 发送随机验证码
export function getRandomValidCode (params) {
  return apiPost('/usercenter/v3/sendcode', params)
}

// 发送随机验证码V4
export function sendVerifyCodeV4 (params) {
  return apiPost('/usercenter/v3/sendVerifyCodeV4', params)
}

export function queryAllChildInfoV30 (params) {
  return apiPost('/children/account/queryAllChildInfoV30', params)
}

/**
 * 验证码登录
 * @param {Object} params
 * @param {Number} account
 * @param {Number} code
 * @param {Boolean} auto
 * @param {String} type
 * @param {String} appCode
 * @param {String} clientType 客户端类型
 */
export const codeLogin = (params) => {
  return apiPost('/usercenter/v3/codeLogin', params)
}

// 邀请注册绑定邀请关系
export const bindInviteRelation = (params) => {
  return apiPost('/activity/bindInviteRelation', params)
}

// 判断邀请码是否有效
export const isShareLinkValid = (params) => {
  return apiPost('/activity/isShareLinkValid', params)
}
/**
 * 第三方账号注册
 * @param {Object} params
 */
export const thirdRegister = (params) => {
  return apiPost('/usercenter/v3/thirdRegister', params)
}
